import React, { useEffect } from "react";
import { withContext } from "../context";
import Loading from "../components/Loading";

const VerifyPayment = ({ history, store, useStoreSlug, cartID }) => {
  useEffect(() => {
    if (history && store && cartID) {
      setTimeout(() => {
        history.push(`${useStoreSlug ? `/${store.slug}` : ""}/comprobante/${cartID}`);
      }, 5000);
    }
  }, [history, store, useStoreSlug, cartID]);

  return <Loading fullscreen />;
};

export default withContext(VerifyPayment);
